<template>
  <div class="home">
    <router-link to="explorer">Explorer</router-link><br>
    <!--<router-link to="bdtnsdebugger">BDTNS Debugger</router-link><br>-->
    <router-link to="zettelkasten">Zettelkasten</router-link>
  </div>
</template>

<script>
export default {
  name: 'home',
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue